/**
 * The orientation of the NavigationBar.
 */

export enum NavigationBarOrientation {
	Vertical = 'vertical',
	Horizontal = 'horizontal',
}
